
import { defineComponent, SetupContext, toRefs, watch } from "vue";
import { BeaconLogInfo } from "@/types/common";
import NativeClient from "@/client/native-client";
import { PAGE_ID } from "@/const/log-const";

export default defineComponent({
  name: "CommonOKDialog",
  props: {
    /**  ダイアログのアクティブ状態 (true: 活性、false: 非活性) */
    showDialog: {
      type: Boolean,
      default: false
    },
    /** ダイアログに表示するテキストメッセージ */
    message: {
      type: String,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    // メッセージ変化の監視
    const { message } = toRefs(props);
    watch(message, () => {
      NativeClient.sendDebugLog("CommonOKDialog watch");
      if (message.value != "") {
        NativeClient.sendDebugLog("CommonOKDialog watch log enable");
        const logInfo = new BeaconLogInfo(PAGE_ID.DIALOG, null, [message.value]);
        NativeClient.sendViewedLog(logInfo);
      }
    });

    // テキスト
    const okText = "OK";

    // OKボタンが押されたことを通知
    const closeClicked = () => context.emit("ok-click");
    return {
      okText,
      closeClicked
    };
  }
});
